export default {
  register_time: 'Register Time',
  authorization_status: 'Authorization Status',
}
